export default {
  init() {
    // JavaScript to be fired on all pages
    $(document).on('click', '.article-row', function (e) {
      e.preventDefault();
      let link = $(this).parent().find('a').attr('href');
      window.location.href = link;
    });

    $('body').on('mouseenter mouseleave', '.dropdown', function (e) {
        $(e.target).dropdown('toggle');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js